var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSendgridIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 2500,
  height: 2500,
  preserveAspectRatio: "xMidYMid",
  viewBox: "0 0 256 256"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#9DE1F3",
  d: "M85.334 85.333H0V256h170.667V85.333z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#27B4E1",
  d: "M85.334 0v170.666H256V0z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#1A82E2",
  d: "M0 256h85.333v-85.333H0zM170.667 85.333H256V0h-85.333z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#239FD7",
  d: "M85.334 170.667h85.333V85.334H85.334z"
})));
export { SvgSendgridIcon as ReactComponent };
export default __webpack_public_path__ + "5e4305d2637ae2471b681f4569426b70.svg";